import config from 'config';

const LOAD = 'horse-racing/naps/LOAD';
const LOAD_SUCCESS = 'horse-racing/naps/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/naps/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        napsList: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(config.api.horseRacing.naps)
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/naps.js